import { USER_AGENT_CLIENT_HINTS_PLACEHOLDER_BRAND_PREFIX, USER_AGENT_DATA_KNOWN_BROWSER_BRANDS } from '@constants/user-agent';
export var getBrowserBrandFromUserAgentData = function (_a) {
    var _b;
    var brands = _a.brands;
    if (!(brands === null || brands === void 0 ? void 0 : brands.length))
        return '';
    var brandNames = brands
        .map(function (entry) { return entry.brand; })
        .filter(function (name) {
        return Boolean(name) && !name.startsWith(USER_AGENT_CLIENT_HINTS_PLACEHOLDER_BRAND_PREFIX);
    });
    for (var _i = 0, USER_AGENT_DATA_KNOWN_BROWSER_BRANDS_1 = USER_AGENT_DATA_KNOWN_BROWSER_BRANDS; _i < USER_AGENT_DATA_KNOWN_BROWSER_BRANDS_1.length; _i++) {
        var knownBrand = USER_AGENT_DATA_KNOWN_BROWSER_BRANDS_1[_i];
        if (brandNames.includes(knownBrand))
            return knownBrand;
    }
    return (_b = brandNames[0]) !== null && _b !== void 0 ? _b : '';
};
